var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddFriendIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 68,
    viewBox: "0 0 100 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 34801"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 34799"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17 59C17 59.64 16.92 60.26 16.76 60.86C16.58 61.66 16.26 62.44 15.84 63.12C14.88 64.74 13.34 66 11.5 66.58C10.72 66.86 9.88 67 9 67C6.94 67 5.08 66.2199 3.68 64.9399C3.08 64.4199 2.56 63.8 2.16 63.12C1.42 61.92 1 60.5 1 59C1 58.12 1.14 57.28 1.4 56.48C1.78 55.32 2.42 54.28 3.26 53.42C4.72 51.92 6.76 51 9 51C11.36 51 13.5 52.02 14.94 53.66C16.22 55.08 17 56.96 17 59Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.9795 58.9688H6.01953",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.99609 56.043V62.0229",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 34800"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M99 50C99 50.64 98.92 51.26 98.76 51.86C98.58 52.66 98.26 53.44 97.84 54.12C96.88 55.74 95.34 57 93.5 57.58C92.72 57.86 91.88 58 91 58C88.94 58 87.08 57.2199 85.68 55.9399C85.08 55.4199 84.56 54.8 84.16 54.12C83.42 52.92 83 51.5 83 50C83 49.12 83.14 48.28 83.4 47.48C83.78 46.32 84.42 45.28 85.26 44.42C86.72 42.92 88.76 42 91 42C93.36 42 95.5 43.02 96.94 44.66C98.22 46.08 99 47.96 99 50Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M93.9795 49.9688H88.0195",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M90.9961 47.043V53.0229",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/user-cirlce-add"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user-cirlce-add"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M47.65 34.3234C51.5298 34.3234 54.675 31.1782 54.675 27.2984C54.675 23.4186 51.5298 20.2734 47.65 20.2734C43.7702 20.2734 40.625 23.4186 40.625 27.2984C40.625 31.1782 43.7702 34.3234 47.65 34.3234Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M60.6297 50.497C60.6297 44.672 54.8297 39.9219 47.6547 39.9219C40.4797 39.9219 34.6797 44.647 34.6797 50.497",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M71.5 31.25C71.5 44.375 60.875 55 47.75 55C34.625 55 24 44.375 24 31.25C24 18.125 34.625 7.5 47.75 7.5C51.025 7.5 54.15 8.14998 57 9.34998C56.675 10.35 56.5 11.4 56.5 12.5C56.5 14.375 57.025 16.15 57.95 17.65C58.45 18.5 59.1 19.2749 59.85 19.9249C61.6 21.5249 63.925 22.5 66.5 22.5C67.6 22.5 68.65 22.3249 69.625 21.9749C70.825 24.8249 71.5 27.975 71.5 31.25Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M76.5 12.5C76.5 13.3 76.4 14.075 76.2 14.825C75.975 15.825 75.575 16.8 75.05 17.65C73.85 19.675 71.925 21.2499 69.625 21.9749C68.65 22.3249 67.6 22.5 66.5 22.5C63.925 22.5 61.6 21.5249 59.85 19.9249C59.1 19.2749 58.45 18.5 57.95 17.65C57.025 16.15 56.5 14.375 56.5 12.5C56.5 11.4 56.675 10.35 57 9.34998C57.475 7.89998 58.275 6.60005 59.325 5.52505C61.15 3.65005 63.7 2.5 66.5 2.5C69.45 2.5 72.125 3.77504 73.925 5.82504C75.525 7.60004 76.5 9.95 76.5 12.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M70.2234 12.4609H62.7734",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M66.4922 8.80469V16.2797",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFriendIcon);
export default __webpack_public_path__ + "static/media/add_friend_icon.84e7b6c99d160f37ca706664a9670845.svg";
export { ForwardRef as ReactComponent };